import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { NavifyService } from '../services/navify.service';


@Injectable({
  providedIn: 'root'
})
export class AppPermissionService {
  constructor(private readonly navifyService: NavifyService,
    private readonly router: Router
  ) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    try {
      const isAllowed = await this.navifyService.checkPermission();
      if (isAllowed) {
        return true;
      }
    } catch {
      // Fail closed when permission resolution errors out.
    }
    this.router.navigate(['u']);
    return false;
  }
}

export const appPermissionGuard: CanActivateFn = (route, state) => {
  return inject(AppPermissionService).canActivate(route, state);
};
